export default __webpack_public_path__ + "static/help-header-33b1263d3da91e9f029e27fc98ff3254.png";